import React, { useLayoutEffect, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { FormField, withForm } from '@gogame/form';
import {
  Stack,
  Box,
  ArrowUpwardIcon,
  IconButton,
  makeStyles,
} from '@gogame/components';

const useStyles = makeStyles(() => ({
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '16px',
    padding: '12px',
  },
  root: {
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
  },
  textField: {
    padding: 0,
    '& .MuiInputBase-formControl': {
      padding: '0 4px',
    },
    '& fieldset': {
      borderColor: 'transparent!important',
    },
  },
  actions: {
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'end',
  },
}));

export const SendMessageForm = withForm({
  enableReinitialize: true,
})(({ submitForm, values, className, isLoading }) => {
  const classes = useStyles();
  const textFieldRef = useRef(null); // Добавляем ref для TextField

  useLayoutEffect(() => {
    if (textFieldRef.current) {
      textFieldRef.current.focus();
    }
  }, []);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        submitForm();
      }
    },
    [submitForm]
  );

  const handleSubmit = useCallback(() => {
    submitForm();
  }, [submitForm]);

  const hasQuery = values?.query?.length > 0;

  return (
    <Box
      component={'footer'}
      bgcolor={'action.hover'}
      color={'text.primary'}
      className={clsx(classes.footer, className)}
    >
      <Stack className={classes.root} spacing={1.5}>
        <FormField.TextField
          className={classes.textField}
          name={'query'}
          placeholder={'Ask anything'}
          multiline
          minRows={1}
          maxRows={8}
          padding={0}
          onKeyDown={handleKeyDown}
          width={'100%'}
          inputRef={textFieldRef}
        />
        <Stack className={classes.actions}>
          <IconButton
            onClick={handleSubmit}
            icon={<ArrowUpwardIcon />}
            size={'small'}
            disabled={!hasQuery || isLoading}
          />
        </Stack>
      </Stack>
    </Box>
  );
});
